import { Chip, Icon, Button } from "@mui/material";
import styled from "styled-components";

export const AppChip = styled(Chip)(
  ({
    theme,
    textColor = "#BE897670",
    backgroundColor = "#BE897626",
    fontSize = "1rem",
    width = "max-content",
  }) => ({
    border: `1px solid ${textColor} !important`,
    backgroundColor: `${backgroundColor} !important`,
    fontSize: `${fontSize} !important`,
    width: width,
    padding: "8px !important",
  })
);

export const AppIcon = styled(Icon)(({ theme }) => ({
  cursor: "pointer",
}));

export const AppButton = styled(Button)(({ theme }) => ({
  backgroundColor: "rgb(190, 137, 118) !important",
  color: "#fff !important",
  fontSize: "1rem !important",
  minWidth: "5rem !important",
  "&:hover": {
    backgroundColor: "#9d5339 !important",
  },
  ":disabled": {
    backgroundColor: "rgba(190, 137, 118, 0.5) !important",
  },
}));

export const AppOutlineButton = styled(Button)(({ theme }) => ({
  borderColor: "#BE8976 !important",
  color: "#BE8976 !important",
  borderRadius: 1,
  fontSize: 14,
  height: 36,
  minWidth: 100,
  px: 2,
  "&:hover": {
    color: "#BE8976 !important",
    borderColor: "#BE8976 !important",
    backgroundColor: "#be897640 !important",
  },
}));
